import { render, staticRenderFns } from "./changeJifenCard.vue?vue&type=template&id=19b9064d&scoped=true&"
import script from "./changeJifenCard.vue?vue&type=script&lang=js&"
export * from "./changeJifenCard.vue?vue&type=script&lang=js&"
import style0 from "./changeJifenCard.vue?vue&type=style&index=0&id=19b9064d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b9064d",
  null
  
)

export default component.exports